export default __webpack_public_path__ + "static/media/youtube01.0ace579c.png";